import script from "./MappingColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./MappingColumn.vue?vue&type=script&setup=true&lang=js"

import "./MappingColumn.vue?vue&type=style&index=0&id=2f76118a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f76118a"]])

export default __exports__